// @ngInject
function SalesChannelsApiService(ResourcesService) {

    var endpoint = 'saleschannels';

    return {
        getSalesChannels: getSalesChannels,
        getSalesChannel: ResourcesService.apiFactory.get(endpoint),
        createSalesChannel: createSalesChannel,
        updateSalesChannel: updateSalesChannel,
        getTenantConfig: ResourcesService.apiFactory.get(endpoint + '/tenantconfig'),
        getPricelists: ResourcesService.apiFactory.get(endpoint + '/pricelists'),
        getCountries: ResourcesService.apiFactory.get(endpoint + '/countries')
    };

    function getSalesChannels(page, filter, pageSize, companyId) {

        var params = {};

        if (page && page > 1) {
            params.page = page - 1;
        }

        if (pageSize && pageSize > 0) {
            params.pageSize = pageSize;
        }

        if (!_.isEmpty(filter)) {
            params.searchTerm = filter;
        }

        var args = { params: params};

        return ResourcesService.apiFactory.get(endpoint)(args);
    }

    function createSalesChannel(salesChannel) {

        var args = {
            salesChannel: salesChannel
        };

        return ResourcesService.apiFactory.create(endpoint,'SalesChannel')(args);
    }

    function updateSalesChannel(salesChannel) {
        var args = {
            salesChannel: salesChannel
        };

        return ResourcesService.apiFactory.update(endpoint,'SalesChannel')(args);
    }

}


angular.module('saleschannels.api', [])
  .factory('SalesChannelsApiService', SalesChannelsApiService);
